module.exports = __webpack_public_path__ + "static/media/icons8-visual-studio-code-2019 - Copy.cda3af2e.svg";